import { styled } from "styled-components";
import { ReactComponent as iconLogo } from "../assets/icons/tbell-logo.svg";
import { footerInfo } from "../assets/datas/ConstantDatas";
import { useContext } from "react";
import { ScreenContext } from "./ScreenProvider";
import { Box } from "@chakra-ui/react";

const FooterContainer = styled(Box)`
  display: flex;
  width: 100%;
  min-height: 314px;
  height: fit-content;
  padding: 4%;
  border-top: 2px solid #e4e4e4;
  z-index: 10;
  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 5%;

    @media (max-width: 768px) {
      flex-direction: column;
      min-height: 400px;
      padding: 10% 5%;
    }
  }
`;
const FooterText = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: white;
  white-space: pre-wrap;
  line-height: 1.5;
`;
const FooterLogo = styled.div`
  display: flex;
  flex: 1;
  height: fit-content;
  justify-content: flex-end;
  align-items: flex-start;
  padding-right: 4%;
  img {
    // width: 70%;
    height: 40px;
  }

  @media (max-width: 1024px) {
    flex: 0;
    margin-bottom: 3%;
    padding-right: 0;
    justify-content: flex-start;
  }
`;
const FooterInfo = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  height: fit-content;
  color: #c5c5c5;

  @media (max-width: 768px) {
    flex: 0;
  }
`;

const ImgLogo = styled(iconLogo)`
  height: 40px;
  fill: #ffffff;
`;

const MainFooter = () => {
  const screen = useContext(ScreenContext).style;
  return (
    <FooterContainer className={"section"} id="main-footer">
        <FooterLogo>
          <ImgLogo />
          {/* <TbellLogo /> */}
        </FooterLogo>
      <FooterInfo>
        <FooterText style={{ fontWeight: "600", fontSize: screen !== "pc" ? "20px" : "12px" }}>
          견적 상담 {screen === "mobile" && footerInfo.phone}
        </FooterText>
        {screen !== "mobile" && 
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <FooterText
              style={{
                fontSize: "25px",
                fontWeight: "700",
                marginRight: "5%",
              }}
            >
              {footerInfo.phone}
            </FooterText>
          </div>
        }
        <FooterText>
          {screen === "mobile"
          ? footerInfo.consulting.replace(`|   월`, `\n월`)
          : footerInfo.consulting}
        </FooterText>
        <div>
          <FooterText>
            {footerInfo.info}
            {screen === "mobile"
            ? footerInfo.contact.replace(`|   Fax`, `\nFax`)
            : footerInfo.contact}
            {footerInfo.address}
            {/* {screen !== "pc" &&
              <FooterMenu>
                <FooterItem>
                  <NavLink to={""}>
                    <FooterText>메뉴1</FooterText>
                  </NavLink>
                </FooterItem>
                <Divider
                  h={"10px"}
                  orientation="vertical"
                  m={"4px 5px"}
                  borderColor={"#595959"}
                />
                <FooterItem>
                  <NavLink to={""}>
                    <FooterText>메뉴2</FooterText>
                  </NavLink>
                </FooterItem>
              </FooterMenu>
            } */}
            {footerInfo.copy}
          </FooterText>
        </div>
      </FooterInfo>
    </FooterContainer>
  );
};

export default MainFooter;
